
export function paymentFeeMethodName(paymnetMethodName) {
    let methodName;
    if(paymnetMethodName == 'bri_va') {
      methodName = 'BRI Virtual Account'
    } else if(paymnetMethodName == 'bca_va') {
      methodName = 'BCA Virtual Account'
    } else if(paymnetMethodName == 'gopay') {
      methodName = 'GoPay'
    } else if(paymnetMethodName == 'echannel') {
      methodName = 'Mandiri Bill'
    } else if(paymnetMethodName == 'bni_va') {
      methodName = 'BNI Virtual Account'
    } else if(paymnetMethodName == 'QRIS') {
      methodName = 'QRIS'
    }
    return methodName;
  }

export function getEpayFeeAmount(payment, total) {
  // Bank transfer and COD have no e-payment fee
  if (!payment || payment === 'bankTransfer' || payment === 'COD') return 0;

  // 2% fee for Gopay
  const gopayFee = (total * 2) / 100;
  // Fixed fee + 11% for Credit Card
  const creditCardFee = 4000 + (total * 11) / 100;
  // 0.7% fee for QRIS
  const qrisFee = (total * 0.7) / 100;
  // Fixed fee for Virtual Accounts (BCA, BNI, eChannel, BRI)
  const virtualAccountFee = 4400;

  let epayFee;
  switch (payment) {
    case 'gopay':
      epayFee = gopayFee;
      break;
    case 'credit_card':
      epayFee = creditCardFee;
      break;
    case 'QRIS':
      epayFee = qrisFee;
      break;
    case 'bca_va':
    case 'bni_va':
    case 'echannel':
    case 'bri_va':
      epayFee = virtualAccountFee;
      break;
    default:
      // Unknown e-payment method — fall back to the order total
      epayFee = total;
      break;
  }

  return Math.round(epayFee);
}

export function calculateEpayFee(payment, feePaidBy, total) {
  // Fee is only billed to the customer when the buyer is paying it.
  // For the seller-pays case, expose the raw amount via getEpayFeeAmount.
  if (feePaidBy !== 'buyer') return 0;
  return getEpayFeeAmount(payment, total);
}

// True when a seller-paid e-payment order can't be charged: the buyer-payable
// total is 0 or below the admin fee the seller has to cover.
export function isOrderBelowEpayFee({ data, payload, totalPrice, cartTotal, formPrice }) {
  if (!data || data.ePaymentFeePaidBy !== 'seller') return false;

  const payment = payload && payload.payment;
  if (!payment || payment === 'bankTransfer' || payment === 'COD') return false;

  const orderTotal = resolveOrderTotal({ totalPrice, cartTotal, formPrice });
  if (orderTotal === null) return false;

  // A coupon can drive the buyer-payable to 0 (MFM-2763). The payment gateway
  // can't charge a 0 amount, so the checkout would hang after the order is
  // recorded — block it up front with the error toast instead.
  if (orderTotal <= 0) return true;

  return orderTotal < getEpayFeeAmount(payment, orderTotal);
}

// Resolve the buyer-payable order total from the most reliable source available:
//   1. totalPrice — buyer payable computed by the form (includes cart, delivery,
//      VAT, discounts/coupons, wholesale tiers). This is the value actually
//      charged, so it's authoritative — use it even when it is 0 (e.g. a coupon
//      covers the whole order).
//   2. cartTotal — cart subtotal, used only when totalPrice is not provided
//      (e.g. preview / unit-test contexts).
//   3. formPrice — the per-unit base price; last-resort fallback only.
// Returns null when no total can be resolved, so the caller skips the check.
function resolveOrderTotal({ totalPrice, cartTotal, formPrice }) {
  if (Number.isFinite(totalPrice)) return totalPrice;
  if (Number.isFinite(cartTotal) && cartTotal > 0) return cartTotal;
  if (Number.isFinite(formPrice) && formPrice > 0) return formPrice;
  return null;
}

// An e-payment order the buyer has not paid yet. Same rule as the server's
// isPaidForSuccessPageTracking: a seller with auto "Terbayar" switched off
// leaves paymentStatus Unpaid, so ePaymentStatus success also counts as paid.
export function isUnpaidEPaymentOrder(order) {
  return order.paymentMode === 'E-Payment' && order.paymentStatus !== 'Paid' && order.ePaymentStatus !== 'success';
}
